import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { WHATSAPP_URL, BOOK_PERIO_PATH, FINANCING_PATH } from "./data";
import { useNavLinks } from "./useCases";
import { scrollToId, EASE } from "./Reveal";


export const MobileMenu = ({ open, onClose }) => {
  const navigate = useNavigate();
  const LINKS = [...useNavLinks(), { id: "dove", label: "Dove siamo" }, { id: "gbt", label: "Igiene GBT", href: "/igiene-gbt" }, { id: "blog", label: "Blog", href: "/blog" }, { id: "rate", label: "Rate a interessi zero", href: FINANCING_PATH }, { id: "prenota", label: "Prenota", href: BOOK_PERIO_PATH }];
  useEffect(() => {
    if (!open) return undefined;
    window.__lenis?.stop();
    document.body.classList.add("menu-open");
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => { window.__lenis?.start(); window.removeEventListener("keydown", onKey); document.body.classList.remove("menu-open"); };
  }, [open, onClose]);

  const go = (id) => { onClose(); setTimeout(() => scrollToId(id), 60); };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div key="scrim" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}
            className="fixed inset-0 -z-10 bg-[#0F2317]/25 backdrop-blur-sm lg:hidden" data-testid="mobile-menu-backdrop" />
          <motion.nav key="panel" initial={{ opacity: 0, y: -12, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: -12, scale: 0.98 }}
            transition={{ duration: 0.45, ease: EASE }} data-lenis-prevent
            className="lg:hidden mx-auto max-w-[1400px] mt-3 rounded-[2rem] bg-[#FCFBF7]/95 backdrop-blur-xl border border-[#1B3B28]/10 shadow-[0_30px_80px_-30px_rgba(27,59,40,0.45)] p-3 max-h-[calc(100vh-110px)] overflow-y-auto"
            data-testid="mobile-menu">
            <ul>
              {LINKS.map((l, i) => (
                <motion.li key={l.id} initial={{ opacity: 0, x: -14 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 + i * 0.04, duration: 0.4, ease: EASE }}>
                  <button onClick={() => (l.href ? (onClose(), navigate(l.href)) : go(l.id))} data-testid={`mobile-menu-link-${l.id}`}
                    className="group w-full flex items-center gap-4 rounded-2xl px-4 py-3.5 text-left hover:bg-[#E6ECE4] active:bg-[#E6ECE4] transition-colors">
                    <span className="f-mono text-xs tracking-[0.2em] text-[#3E6B48] w-6">{String(i + 1).padStart(2, "0")}</span>
                    <span className="f-serif text-[1.7rem] leading-none text-[#1B3B28] flex-1">{l.label}</span>
                    <ArrowUpRight size={16} className="text-[#3E6B48] opacity-40 transition-transform group-hover:rotate-45 group-hover:opacity-100" />
                  </button>
                </motion.li>
              ))}
            </ul>
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 }} className="grid grid-cols-2 gap-2 mt-2 p-1">
              <button onClick={() => { onClose(); navigate(BOOK_PERIO_PATH); }} data-testid="mobile-menu-booking-btn"
                className="rounded-full bg-[#1B3B28] text-[#FCFBF7] py-3.5 text-sm hover:bg-[#3E6B48] transition-colors">Prima visita</button>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-menu-whatsapp"
                className="rounded-full border border-[#1B3B28]/20 text-[#1B3B28] py-3.5 text-sm flex items-center justify-center gap-2 hover:bg-[#E6ECE4] transition-colors">
                <MessageCircle size={15} /> WhatsApp
              </a>
            </motion.div>
          </motion.nav>
        </>
      )}
    </AnimatePresence>
  );
};
